<div class="logo-wrapper">
	<img src="/assets/images/logo.svg" class="logo" />
</div>

<div class="content">
	<div class="title">{{ 'sharing.social-tag.title' | translate }}</div>
	<div class="subtitle">{{ 'sharing.social-tag.subtitle' | translate }}</div>
</div>
